export default {
  OPEN_DOWNLOAD_MODAL: 'OPEN_DOWNLOAD_MODAL',
  OPEN_DOWNLOAD_MODAL_SUCCESS: 'OPEN_DOWNLOAD_MODAL_SUCCESS',
  CLOSE_DOWNLOAD_MODAL: 'CLOSE_DOWNLOAD_MODAL',
  POST_BULK_DOWNLOAD: 'POST_BULK_DOWNLOAD'
}
